export const CONTEXT_LENGTH = 50;
export const MAX_CACHE_SIZE = 20;
import { SmartComposeInteraction } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';

export interface CachedSuggestion {
    context: string;
    suggestion: string;
    suggestionTelemetry: SmartComposeInteraction;
}
